(async function () {
  // EVENT LISTENERS
  // Open bundle detail
  document.querySelectorAll(".c15__bundle").forEach((bundle) => {
    bundle.addEventListener("click", toggleDetails);
  });

  // Show another variant
  document.querySelectorAll(".c15__variant-container").forEach((button) => {
    button.addEventListener("click", toggleVariant);
  });

  // Add multiple items to cart
  document.querySelectorAll(".c15__button").forEach((button) => {
    button.addEventListener("click", add);
  });

  // Change bundle detail order on desktop and mobile
  const mediaQuery = window.matchMedia("(min-width: 990px)");
  mediaQuery.addEventListener("change", handleOrder);

  // TOGGLES
  function toggleDetails(e) {
    const _e = e.target.localName == "div" ? e.target : e.target.parentNode;
    const collectionId = _e.dataset.collection;
    console.log(
      e.target,
      document.querySelector(
        `.c15__collection[data-collection='${collectionId}']`
      )
    );
    document
      .querySelector(`.c15__collection[data-collection='${collectionId}']`)
      .classList.toggle("hidden");
    document
      .querySelectorAll(
        `.c15__collection:not([data-collection='${collectionId}'])`
      )
      .forEach((collection) => collection.classList.add("hidden"));

    document
      .querySelectorAll(`.c15__bundle:not([data-collection='${collectionId}'])`)
      .forEach((bundle) => (bundle.dataset.active = ""));
    e.target.parentNode.dataset.active =
      e.target.parentNode.dataset.active == "active" ? "" : "active";
  }

  function toggleVariant(e) {
    const _e = e.target.localName == "div" ? e.target.children[0] : e.target;
    const collectionId = _e.dataset.collection,
      productId = _e.dataset.product,
      variantId = _e.dataset.variant,
      title = _e.dataset.title,
      count = _e.dataset.count;
    console.log(count);

    // Variant button
    document.querySelector(
      `button[data-collection='${collectionId}'][data-product='${productId}'][data-variant='${variantId}'][data-count='${count}']`
    ).dataset.active = "active";
    document
      .querySelectorAll(
        `button[data-collection='${collectionId}'][data-product='${productId}'][data-count='${count}']:not([data-variant='${variantId}'])`
      )
      .forEach((collection) => (collection.dataset.active = ""));

    // Variant image
    document.querySelector(
      `img[data-collection='${collectionId}'][data-product='${productId}'][data-variant='${variantId}'][data-count='${count}']`
    ).dataset.active = "active";
    document
      .querySelectorAll(
        `img[data-collection='${collectionId}'][data-product='${productId}'][data-count='${count}']:not([data-variant='${variantId}'])`
      )
      .forEach((collection) => (collection.dataset.active = ""));

    // Variant title
    document.querySelector(
      `.c15__product[data-collection='${collectionId}'][data-product='${productId}'][data-count='${count}'] span`
    ).innerHTML = title;
  }

  // ADD TO CART
  function add(e) {
    if (window.Tapcart.isInitialized) {
      addToCartTapcart(e);
    } else {
      let body = { items: [] };

      e.target.parentNode.parentNode
        .querySelectorAll(
          ".c15__variant-container button[data-active='active']"
        )
        .forEach((variant) => {
          body.items.push({
            id: parseInt(variant.dataset.variant),
            quantity: parseInt("1"),
          });
        });

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then((response) => {
          response.json();
        })
        .then(() => {
          window.location = "/cart";
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  function addToCartTapcart(e) {
    let items = { lineItems: [] };

    e.target.parentNode.parentNode
      .querySelectorAll(".c15__variant-container button[data-active='active']")
      .forEach((variant) => {
        items.lineItems.push({
          variantId: variant.dataset.variant,
          quantity: 1,
        });
      });

    window.Tapcart.actions.addToCart(items);
    window.Tapcart.actions.showToast({
      message: "Added to cart",
      type: "success",
    });
  }

  // MEDIA QUERY
  function handleOrder(e) {
    let orderBundle, orderDetail, modulus, increment;
    if (e.matches) {
      orderBundle = 1;
      orderDetail = 5;
      modulus = 4;
      increment = 5;
    } else {
      orderBundle = 1;
      orderDetail = 3;
      modulus = 2;
      increment = 3;
    }

    document
      .querySelectorAll(`.c15__bundle-list .c15__bundle`)
      .forEach((bundle) => {
        bundle.style.order = orderBundle;
        if (orderBundle % modulus != 0) {
          orderBundle++;
        } else {
          orderBundle = orderBundle + increment;
        }
      });

    document
      .querySelectorAll(`.c15__bundle-list .c15__collection`)
      .forEach((bundle) => {
        bundle.style.order = orderDetail;
        if (orderDetail % modulus != 0) {
          orderDetail++;
        } else {
          orderDetail = orderDetail + increment;
        }
      });
  }

  // RUN ON STARTUP
  handleOrder(mediaQuery);
})();
